import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";

const axisNameColor = '#334155';
const completedBarColor = '#00ff88';
const pendingBarColor = '#b6c2bd';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'

const StackerChart = ({
    chartData = [],
    chartLabel,
    purpose = "",
    completedLabel = "Completed",
    pendingLabel = "Pending",
    showXAxisLabel

}) => {

    const option = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
            formatter: (params) => {
                const index = params[0].dataIndex;
                const item = chartData[index];

                let html = `
            <b>${item.resourceName}</b><br/>
            ${completedLabel} : ${item.completed.hours} hrs<br/>
            ${pendingLabel} : ${item.pending.hours} hrs
        `;
                if (purpose) {
                    html += `
                <hr style="margin:6px 0"/>
                <b>Purpose</b><br/>
                ${purpose}
            `;
                }

                return html;
            },
        },
        legend: {
            show: true,
            top: 5,
            left: "center",

            data: [
                completedLabel,
                pendingLabel,
            ],
            
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        grid: {
            left: 40,
            right: 20,
            top: 40,
            bottom: 35,
        },

        xAxis: {
            type: "category",
            data: chartData.map(item => item.resourceName),
            axisTick: {
                show: false,
            },
            name: "Employees",
            nameLocation: "middle",
            nameGap: 50, 
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLabel: {
                show: showXAxisLabel,
                color: labelColor,
                fontSize: 11,
                rotate: 20,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            splitLine: {
                show: false,
            },
        },

        yAxis: {
            type: "value",
            show: true,
            name: "Work Hours",
            nameLocation: "middle",
            nameGap: 50,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            splitLine: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            }
        },

        series: [
            {
                name: completedLabel,
                type: "bar",
                // stack: "total",
                data: chartData.map(item => item.completed.hours),
                barWidth: 15,
                barGap: "0%",
                // barCategoryGap: "40%",
                itemStyle: {
                    color: completedBarColor,
                    borderRadius: [2, 2, 0, 0],
                },
            },
            {
                name: pendingLabel,
                type: "bar",
                // stack: "total",
                // barGap: '20%',
                data: chartData.map(item => item.pending.hours),
                barWidth: 15,
                // barCategoryGap: "40%",
                itemStyle: {
                    color: pendingBarColor,
                    borderRadius: [2, 2, 0, 0],
                },
            },
        ]
    };

    return (
        <ChartCard
            title={chartLabel}
            height={350}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default StackerChart;